export class AppSettings {
  public static API_URL = 'https://bricokarty.pointer.pl/AkartServiceModel1/service/';
  // public static API_URL = 'https://bricokartydemo.pointer.pl/AkartServiceModel1/service/';
}


